import React, { useEffect, useState, memo } from "react";
import { Dialog, DialogContent, Typography, Button, Box, Grid } from "@mui/material";
import { getText } from "../../libs/utils";
import { ArrowRight } from "../../assets/images/icons";
import { useNavigate } from 'react-router-dom';
import REST from '../../libs/API.js'
import PSIcon from '../../components/PSIcon';
import {styled} from '@mui/material/styles';

const MyBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  margin: '15px 0 25px',
  gap: '10px',
  ".item": {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    "&:last-child": {
      justifyContent: 'start'
    }
  },
  ".arrow": {},
}))

function UpdateOrderRates({ open, order, onAccept }) {
  const navigate = useNavigate();
  const [rateData, setRateData] = useState(null);
  const updateOrderRate = () => {
    REST.getNewRate(order.code).then(data => {
      if (data.success) {
        setRateData(data.data);
      }
    })
  }

  const refuseNewRate = () => {
    REST.refuseNewRate(order.code).then(data => {
      if (data.success) {
        navigate('/account');
        // setRateData(null);
        // onAccept();
      }
    })
  }

  const acceptNewRate = () => {
    REST.acceptNewRate(order.code).then(data => {
      if (data.success) {
        setRateData(null);
        onAccept();
      }
    })
  }

  useEffect(() => {
    if (open) {
      updateOrderRate();
    }
  }, [open]);


  if (!rateData) {
    return false
  }

  const { from = {}, to = {} } = rateData;

  return (
    <Dialog
      onClose={null}
      open={open}
      maxWidth="sm"
      className="updateRate"
    >
      <DialogContent sx={{ textAlign: 'center', padding: '20px' }}>
        <Typography variant="h4">{getText('orderPayTimeOut')}</Typography>
        <Typography variant="caption" sx={{ display: 'inline-block', margin: '8px 0 20px', maxWidth: '280px' }}>
          {getText('orderPayTimeOutExplain')}
        </Typography>

        <MyBox>
          <Box className="item">
            <PSIcon
              name={from.className}
              height={28}
              width={28}
              margin="0 10px 0 0"
            />
            <Box sx={{ textAlign: 'left', position: 'relative' }}>
              <Typography variant="boldCaption" component="div">{from.amount} {from.currency}</Typography>
              <Typography variant="greyCaption">{from.name}</Typography>
              {/* {Number(from.difference) != 0
                ? <Typography variant="greenRate">{Number(from.difference) > 0 ? "+" + from.difference : from.difference} {from.currency}</Typography>
                : <Typography variant="greenRate" sx={{color: 'primary.greyText'}}>{getText('noChanges')}</Typography>} */}
            </Box>
          </Box>
          <Box className="arrow" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><ArrowRight width="15" height="15" /></Box>
          <Box className="item">
            <PSIcon
              name={to.className}
              height={28}
              width={28}
              margin="0 10px 0 0"
            />
            <Box sx={{ textAlign: 'left', position: 'relative' }}>
              <Typography variant="boldCaption" component="div">{to.amount} {to.currency}</Typography>
              <Typography variant="greyCaption">{to.name}</Typography>
              {Number(to.difference) != 0
                ? <Typography variant="greenRate">{Number(to.difference) > 0 ? "+" + to.difference : to.difference} {to.currency}</Typography>
                : <Typography variant="greenRate" sx={{color: 'primary.greyText'}}>{getText('noChanges')}</Typography>}
            </Box>
          </Box>
        </MyBox>

        <Button
          variant="contained"
          size="medium"
          fullWidth
          sx={{ padding: '16px 0' }}
          onClick={acceptNewRate}>
          {getText("acceptNewOrderRates")}
        </Button>

        <Box onClick={refuseNewRate} sx={{ margin: '20px 0 5px' }}><Typography variant="linkGrey">{getText("closeOrder")}</Typography></Box>

      </DialogContent>
    </Dialog>
  );
}

// export default UpdateOrderRates
export default memo(UpdateOrderRates)